import React, {useEffect} from 'react'
import SwaggerUI from 'swagger-ui'
import {Loader} from 'semantic-ui-react'
import 'swagger-ui/dist/swagger-ui.css'
import {asJson} from '../../../../util'
import {useSafeState} from '../../../../hook'

const OASUI = (
  {
    domId = '#swagger-ui',
    contract = {definition: ''}
  }
) => {
  const [loading, setLoading] = useSafeState(true)

  function download(filename, text) {
    var element = document.createElement('a')
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
    element.setAttribute('download', filename)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }

  useEffect(() => {
    window.oas_ui = SwaggerUI({
      dom_id: domId,
      spec: asJson(contract.definition),
      onComplete: () => {
        const downloadContainer = document.createElement('DIV')
        downloadContainer.className = 'wrapper'
        downloadContainer.style.marginBottom = '15px'
        const downloadLink = document.createElement('A')
        downloadLink.className = 'btn'
        downloadLink.setAttribute('href', '')
        downloadLink.addEventListener('click', function () {
          download('contract.json', JSON.stringify(asJson(contract.definition), null, 2))
        }, false)
        downloadLink.innerText = 'Download'
        downloadContainer.appendChild(downloadLink)
        const informationContainer = document.getElementsByClassName('information-container')[0]
        informationContainer.parentNode.insertBefore(downloadContainer, informationContainer.nextSibling)
        setLoading(false)
        window.scrollTo(0, 0)
      }
    })

  }, [])

  return (
    <>
      <Loader active={loading}/>
      <div id={domId.replace('#', '')} style={{display: loading ? 'none' : 'block'}} data-testid='docs-oas-container'/>
    </>
  )
}

export {OASUI}

export default OASUI